import { ComponentPropsWithoutRef, ReactNode } from 'react';
import styled from 'styled-components';

import { theme } from '../ui/theme';

export interface TdProps extends ComponentPropsWithoutRef<'td'> {
    danger?: boolean;
    children?: ReactNode;
}

export const Td = styled.td<TdProps>`
    color: ${(props) => (props.danger ? theme.colors.negative.foreground : 'inherit')};
`;
